const firstArray = (...candidates) =>
  candidates.find((candidate) => Array.isArray(candidate)) ?? [];

export const unwrapData = (response) => {
  const body = response?.data;
  return body?.data?.data ?? body?.data ?? body;
};

export const unwrapArray = (response) => {
  const body = response?.data;
  return firstArray(body?.data?.data, body?.data?.items, body?.data, body);
};

export const unwrapPage = (response) => {
  const body = response?.data;
  const data = firstArray(
    body?.data?.items,
    body?.data?.data,
    body?.data,
    body,
  );
  const totalCount =
    body?.data?.totalCount ??
    body?.data?.total ??
    body?.totalCount ??
    body?.total ??
    data.length;
  return { data, totalCount };
};
